import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ExperimentalInputsContextProperties} from 'procedures/planning/ProcedurePlanTypes';

import {ExperimentFlowchart} from './ExperimentalInputs';
import {ParameterValuesTabContents} from './StudyDesignTabSharedComponents';

interface ProcedureRunDesignEditorRightSidepanelProps {
  templateFlowchart: ExperimentFlowchart;
  selectedMethodId: string;
  onChangeSelectedMethod: (newMethodId: string) => void;
  procedureType: ProcedureType;
  context: ExperimentalInputsContextProperties;
}

export default function ProcedureRunDesignEditorRightSidepanel(
  props: ProcedureRunDesignEditorRightSidepanelProps
): JSX.Element {
  return (
    <ParameterValuesTabContents
      methods={props.templateFlowchart.nodes}
      procedureFlowchart={props.templateFlowchart}
      selectedMethodId={props.selectedMethodId}
      onChangeSelectedMethod={props.onChangeSelectedMethod}
      procedureType={props.procedureType}
      context={props.context}
    />
  );
}
